var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"landing-home-page"},[_c('AppHero'),_c('HomeAbout')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }